import React, { useEffect, useState, useRef } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Pagination } from "antd";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import PropTypes from "prop-types";

const HomePageCustomizedDragNDrop = ({
  columns = [],
  rows = [],
  page = 1,
  setPage = () => { },
  setPageSize = () => { },
  count = 0,
  render = () => null,
  pageSize = rows?.length || 10,
  sortHandler = () => { },
  setRows = () => { },
  updatePosition = async () => { },
  disableDrag = false,
  onDragStart,
  onDragEndDone,
}) => {
  const [, dispatch] = useDataLayerValue();

  // ✅ ONE ref for all rows (DO NOT MOVE THIS)
  const rowRefs = useRef({});

  useEffect(() => {
    if (typeof setPage === "function") {
      setPage(1);
    }
  }, [pageSize]);

  const onChange = (pageNumber) => {
    if (typeof setPage === "function") {
      setPage(pageNumber);
      setRows([]);
    }
  };

  const onSizeChange = (current, size) => {
    if (typeof setPageSize === "function") {
      setPageSize(size);
    }
  };

  const [sortBy, setSortBy] = useState({
    column: null,
    order: "asc",
  });

  const handleSort = (column) => {
    sortHandler({
      columnKey: column,
      order:
        sortBy.column === column && sortBy.order === "asc"
          ? "descend"
          : "ascend",
    });

    setSortBy((prev) => ({
      column,
      order:
        prev.column === column && prev.order === "asc" ? "desc" : "asc",
    }));
  };

  const handleDragEnd = async (result) => {
    if (!result.destination) return;

    const updatedRows = Array.from(rows);
    const [movedElement] = updatedRows.splice(result.source.index, 1);
    updatedRows.splice(result.destination.index, 0, movedElement);

    const newRows = updatedRows.map((row, index) => ({
      ...row,
      position: (page - 1) * pageSize + index + 1,
    }));

    setRows(newRows);

    const finalPosition =
      (page - 1) * pageSize + result.destination.index + 1;

    dispatch({ type: "SET_LOADING", loading: true });

    try {
      await updatePosition(newRows, {
        movedElement,
        finalPosition,
      });
    } catch (error) {
      console.error("Failed to update position:", error);
    } finally {
      dispatch({ type: "SET_LOADING", loading: false });
    }
  };


  const getItemStyle = (style, snapshot, element) => {
    if (!snapshot.isDragging || !element) return style;

    return {
      ...style,
      width: element.getBoundingClientRect().width,
      maxWidth: element.getBoundingClientRect().width,
    };
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <div className="table_holder">
        <DragDropContext
          onDragStart={onDragStart}
          onDragEnd={async (result) => {
            await handleDragEnd(result);
            onDragEndDone?.();
          }}
        >
          <table id="voucher_list" className="table table-bordered table-striped">
            <Droppable droppableId="droppable-1">
              {(provided) => (
                <tbody ref={provided.innerRef} {...provided.droppableProps}>
                  {rows.length > 0 ? (
                    rows.map((row, index) => (
                      <Draggable
                        draggableId={row.id.toString()}
                        key={row.id}
                        index={index}
                        isDragDisabled={disableDrag}
                      >
                        {(provided, snapshot) => (
                          <tr
                            ref={(el) => {
                              provided.innerRef(el);
                              if (el) rowRefs.current[row.id] = el;
                            }}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              provided.draggableProps.style,
                              snapshot,
                              rowRefs.current[row.id]
                            )}
                          >
                            <td colSpan={columns.length} style={{ width: "100%", display: "block" }}>
                              <div style={{ width: "100%", boxSizing: "border-box" }}>
                                {render(row, index)}
                              </div>
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    ))
                  ) : (
                    <tr>
                      <td
                        valign="top"
                        colSpan={columns.length}
                        className="dataTables_empty"
                      >
                        No matching records found
                      </td>
                    </tr>
                  )}
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
          </table>
        </DragDropContext>
      </div>

      {count > 10 && typeof setPage === "function" && (
        <Pagination
          showSizeChanger
          pageSizeOptions={["5", "10", "20", "50"]}
          onShowSizeChange={onSizeChange}
          style={{ marginLeft: "auto", marginTop: "10px" }}
          defaultCurrent={page}
          current={page}
          onChange={onChange}
          total={count}
        />
      )}
    </div>
  );
};

HomePageCustomizedDragNDrop.propTypes = {
  columns: PropTypes.any,
  rows: PropTypes.any,
  page: PropTypes.any,
  setPage: PropTypes.any,
  setPageSize: PropTypes.any,
  count: PropTypes.any,
  pageSize: PropTypes.any,
  sortHandler: PropTypes.any,
  setRows: PropTypes.any,
  updatePosition: PropTypes.any,
  render: PropTypes.func,
};

export default HomePageCustomizedDragNDrop;
